import { render } from "./CustomDomainPro.vue?vue&type=template&id=1008bc4b"
import script from "./CustomDomainPro.vue?vue&type=script&lang=js"
export * from "./CustomDomainPro.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.7.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__